import {IMeasurement} from "../../../types/models/Calibration.ts";
import React from "react";
import {
    Paper,
    Table, TableBody, TableCell,
    TableContainer,
    TableRow,
    Typography
} from "@mui/material";
import {MeasurementIcon} from "../MeasurementIcon.tsx";

export interface IMeasurementListProps {
    measurement: IMeasurement;
}

export function Measurement(props: IMeasurementListProps) {

    const {measurement} = props;

    let val = measurement.value;

    if (!(typeof measurement.value === 'object' && measurement.value !== null)) {
        val = {[measurement.type.toLowerCase()] : measurement.value};
    }

    return (
        <>
            <Typography variant="subtitle1">
                Measurements
            </Typography>
            <TableContainer component={Paper} sx={{mt: 1}}>
                <Table sx={{minWidth: 300}} size="small">
                    <TableBody>
                        {Object.entries(val).map(([label, value]) => {
                            return <TableRow
                                key={label}
                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                            >
                                <TableCell component="th" scope="row">
                                    <MeasurementIcon icon={label}/>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {label}
                                </TableCell>
                                <TableCell align="right">{value}</TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <Typography variant="subtitle1" sx={{mt: 2}}>
                Parameters
            </Typography>
            <TableContainer component={Paper} sx={{mt: 1}}>
                <Table sx={{minWidth: 300}} size="small">
                    <TableBody>
                        {Object.entries(measurement.parameters ?? []).map(([label, value]) => {
                            return <TableRow
                                key={label}
                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                            >
                                <TableCell component="th" scope="row">
                                    <MeasurementIcon icon={label}/>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {label}
                                </TableCell>
                                <TableCell align="right">
                                    {value?.toString()}
                                </TableCell>
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}